// test2530
(2530 && 0);
